module.exports = __webpack_public_path__ + "img/Weapon_259.134a8286.png";